/**
 * Send B2B buyers to their company-tagged catalog once per login.
 *
 * The stored flag means "this login has already been handled". It is keyed per
 * customer in localStorage, so extra tabs and pasted links never re-trigger it.
 * Only neutral landings (storefront root, account page) redirect; a deep link is
 * honoured as-is and still marks the login handled, so later clicks around the
 * store are never hijacked. The flag is cleared while logged out so the next
 * login redirects again.
 *
 * Prefer: laanin-kuljetus (shared Läänin/Tavarataksi company) → exact company
 * handle → fuzzy handle match → first URL alphabetically.
 */
(function () {
  var PREFIX = 'b2b_login_redirect_done';
  var PREFERRED_HANDLE = 'laanin-kuljetus';
  var el = document.getElementById('b2b-login-redirect-data');
  if (!el) return;

  var data;
  try {
    data = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }

  // localStorage survives new tabs; sessionStorage is the private-mode fallback.
  var store = null;
  try {
    store = window.localStorage;
    store.setItem(PREFIX + '_probe', '1');
    store.removeItem(PREFIX + '_probe');
  } catch (e) {
    try {
      store = window.sessionStorage;
    } catch (e2) {
      return;
    }
  }
  if (!store) return;

  function clearFlags() {
    try {
      for (var i = store.length - 1; i >= 0; i--) {
        var k = store.key(i);
        if (k && k.indexOf(PREFIX) === 0) store.removeItem(k);
      }
    } catch (e) {
      /* ignore */
    }
  }

  // Guest / no company catalog: clear flags so a future login redirects.
  if (!data || !Array.isArray(data.urls) || !data.urls.length) {
    clearFlags();
    return;
  }

  var key = PREFIX + ':' + (data.customerId || 'current');
  try {
    if (store.getItem(key)) return;
  } catch (e) {
    return;
  }

  function trimSlash(u) {
    return String(u || '').replace(/\/+$/, '');
  }

  function isCleanPath(u) {
    if (typeof u !== 'string' || !u) return false;
    // Reject mangled JSON leftovers (quotes/commas) and non-path values.
    if (u.indexOf('"') !== -1 || u.indexOf(',') !== -1) return false;
    return u.charAt(0) === '/';
  }

  var urls = data.urls.filter(isCleanPath);
  var handles = Array.isArray(data.handles) ? data.handles : [];
  if (!urls.length) return;

  // Keep handle/url pairs aligned when both arrays are the same length.
  if (handles.length === data.urls.length) {
    var pairedHandles = [];
    for (var p = 0; p < data.urls.length; p++) {
      if (isCleanPath(data.urls[p])) pairedHandles.push(handles[p]);
    }
    handles = pairedHandles;
  } else {
    handles = [];
  }

  var companyHandle = (data.companyHandle || '').toLowerCase().trim();
  var target = null;

  function urlForHandle(wanted) {
    if (handles.length !== urls.length) return null;
    for (var i = 0; i < handles.length; i++) {
      if (String(handles[i] || '').toLowerCase() === wanted) return urls[i];
    }
    return null;
  }

  // Shared company has two catalogs (Läänin + Tavarataksi); always prefer Läänin.
  target = urlForHandle(PREFERRED_HANDLE);

  if (!target && companyHandle && handles.length === urls.length) {
    target = urlForHandle(companyHandle);
  }

  if (!target && companyHandle && handles.length === urls.length) {
    for (var j = 0; j < handles.length; j++) {
      var hj = String(handles[j] || '').toLowerCase();
      if (hj.indexOf(companyHandle) !== -1 || companyHandle.indexOf(hj) !== -1) {
        target = urls[j];
        break;
      }
    }
  }

  if (!target) {
    urls.sort(function (a, b) {
      return a.localeCompare(b);
    });
    target = urls[0];
  }

  if (!isCleanPath(target)) return;

  var path = trimSlash(window.location.pathname);
  var alreadyOnMatch = urls.some(function (url) {
    var u = trimSlash(url);
    return path === u || path.indexOf(u + '/') === 0;
  });

  // Drop the locale prefix (/fi, /en-gb) so path checks work in every market.
  var root = trimSlash(data.rootUrl);
  var relative = path;
  if (root && (path === root || path.indexOf(root + '/') === 0)) {
    relative = path.slice(root.length);
  }
  relative = relative || '/';

  var accountPath = trimSlash(data.accountUrl) || '/account';
  if (root && accountPath.indexOf(root) === 0) {
    accountPath = accountPath.slice(root.length) || '/account';
  }

  // Only a landing with no intent of its own may be replaced by the catalog.
  var isNeutralLanding =
    relative === '/' || relative === accountPath || relative === accountPath + '/login';

  // Mark the login handled on the first page seen, so nothing redirects later.
  try {
    store.setItem(key, '1');
  } catch (e) {
    /* ignore */
  }

  if (alreadyOnMatch) return;
  if (!isNeutralLanding) return;

  window.location.assign(target);
})();
